/* polyfill.js */ function _(require, module, exports) {
    require(2) /* es5-ext/object/assign/implement */;
    require(11) /* es5-ext/number/is-integer/implement */;
    require(14) /* es5-ext/string/#/repeat/implement */;
    require(21) /* es5-ext/array/from/implement */;
    require(49) /* es5-ext/math/log10/implement */;
    require(52) /* es6-set/implement */;
    require(87) /* es6-map/implement */;
    require(94) /* es6-weak-map/implement */;
    require(100) /* es6-promise/auto */;
}
